import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedTrainer: null,
  trainers: [],
  loading: false,
  error: null
};

const trainerSlice = createSlice({
  name: 'trainer',
  initialState,
  reducers: {
    setSelectedTrainer: (state, action) => {
      state.selectedTrainer = action.payload;
    },
    setTrainers: (state, action) => {
      state.trainers = action.payload;
    },
    updateTrainer: (state, action) => {
      const updatedTrainer = action.payload;
      state.trainers = state.trainers.map(trainer => 
        trainer.trainerId === updatedTrainer.trainerId ? updatedTrainer : trainer
      );
      if (state.selectedTrainer?.trainerId === updatedTrainer.trainerId) {
        state.selectedTrainer = updatedTrainer;
      }
    },
    clearSelectedTrainer: (state) => {
      state.selectedTrainer = null;
    }
  }
});

export const { setSelectedTrainer, setTrainers, updateTrainer, clearSelectedTrainer } = trainerSlice.actions;
export default trainerSlice.reducer; 